import * as React from "react"
import { Context } from "@contexts/BookingsCtx.tsx"

const useBookingsCtx = () => React.useContext(Context)

export default useBookingsCtx
